module.exports = __webpack_public_path__ + "img/kid9.4c6d98b5.png";